export default __webpack_public_path__ + "assets/0016_assist-card 1.svg";